import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
// Self-hosted Inter (no render-blocking Google Fonts request; GDPR-friendly).
// Variable font: one file covers all weights (400-800) instead of 5 separate
// woff2 downloads.
import '@fontsource-variable/inter'
import './index.css'
import { App } from './App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>,
)
